<template>
  <div class="DataTable" style="width: 100% !important">
    <v-container style="padding-top: 0px !important">
      <v-form ref="form1" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex
            xs12
            pa-2
            style="padding-bottom: 5px !important; font-size: medium"
          >
            <template v-if="company !== undefined">
              {{ company.name }}
            </template>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs4 pa-2>
            <v-menu
              ref="menuKupovine"
              v-model="menuKupovine"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              :disabled="!deletable"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormattedKupovine"
                label="Datum razduženja"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                @blur="dateRazduzenja = parseDate(dateFormattedKupovine)"
                :disabled="!deletable"
              ></v-text-field>
              <v-date-picker
                v-model="dateRazduzenja"
                no-title
                @input="menuKupovine = false"
                :max="maxDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex
            xs2
            pa-2
            style="padding-left: 4px !important; padding-right: 4px !important"
          >
            <v-menu
              ref="menu11"
              :close-on-content-click="false"
              v-model="menu11"
              :nudge-right="0"
              :return-value.sync="time1"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
              @input="
                (value) =>
                  value && $refs.picker && ($refs.picker.selectingHour = true)
              "
              :disabled="!deletable"
            >
              <v-text-field
                slot="activator"
                v-model="time1"
                label=""
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                :disabled="!deletable"
              ></v-text-field>
              <v-time-picker
                v-model="time1"
                ref="picker"
                full-width
                landscape
                class="mt-3"
                format="24hr"
                :allowed-minutes="allowedStep"
                v-on:change="$refs.menu11.save(time1)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu11 = false"
                  >Cancel</v-btn
                >
              </v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs4 pa-2>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                label="Datum uplate"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                @blur="date = parseDate(dateFormatted)"
              ></v-text-field>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu = false"
                :max="maxDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex
            xs2
            pa-2
            style="padding-left: 4px !important; padding-right: 4px !important"
          >
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="0"
              :return-value.sync="time"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
              @input="
                (value) =>
                  value && $refs.picker && ($refs.picker.selectingHour = true)
              "
            >
              <v-text-field
                slot="activator"
                v-model="time"
                label=""
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
              ></v-text-field>
              <v-time-picker
                v-model="time"
                ref="picker"
                full-width
                landscape
                class="mt-3"
                format="24hr"
                :allowed-minutes="allowedStep"
                v-on:change="$refs.menu1.save(time)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu1 = false"
                  >Cancel</v-btn
                >
              </v-time-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-form>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs7 pa-2>
            <v-autocomplete
              v-model="employee_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Uplatio"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
            ></v-autocomplete>
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs3 pa-2>
            <v-text-field
              v-model="iznos"
              label="Iznos"
              type="number"
              required
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'Obavezan podatak']"
            ></v-text-field>
          </v-flex>
          <v-flex xs1 style="padding-top: 23px; font-size: 16px"> RSD </v-flex>
        </v-layout>
        <v-layout row wrap>
          <!-- <v-flex xs12 pa-2>
            <v-textarea v-model="opis" name="input-5-1" class="Description" label="Opis"></v-textarea>
          </v-flex> -->
          <v-flex xs12 pa-2>
            <v-text-field
              v-model="opis"
              label="Opis"
              :disabled="!edit_form"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex
            xs12
            style="text-align: right; margin-bottom: 0px; padding-top: 15px"
          >
            <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
              >Sačuvaj</v-btn
            >
            <v-btn id="Odustani_dugme" @click="clear" class="AppButtonOutlined"
              >odustani</v-btn
            >
          </v-flex>
        </v-layout>
      </v-form>

      <TokenComponent ref="frmtoken" />
    </v-container>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  props: ["item", "warehouseID", "company"],
  name: "AddingItem",
  components: {
    TokenComponent,
  },
  data: () => ({
    menu: "",
    menu1: "",
    time: "",
    menu11: "",
    time1: "",
    date: null,
    menuKupovine: "",
    dateRazduzenja: null,
    valid: true,
    dateFormatted: null,
    dateFormattedKupovine: null,
    naziv: "",
    ID: 0,
    type: "input",
    input: true,
    receive_id: 0,
    opis: "",
    employee_to_items: [],
    employee_to_select: 0,
    give: undefined,
    quantity: undefined,
    iznos: undefined,
    // jm_valuta: undefined,
    porez: 0,
    vrednost: 0,
    lot: "",
    warehouseType: "",
    edit_form: true,
    number: "",
    itemId: [],
    deletable: false,
  }),
  watch: {
    item: function (val) {
      

      if (val.id !== 0) this.deletable = val.isDeletable;
      else this.deletable = true;

      this.clear();
    },
    company: function (val) {},
    warehouseID: function (val) {
      

      if (this.item.id !== undefined) {
        this.ID = this.item.id;

        if (val !== 0 && this.item.id !== 0) {
          this.employee_to_select = this.item.employeePaid;
          this.iznos = this.item.value;
          this.description = this.item.description;
          this.dateRazduzenja = this.item.dateOfDischarge.split("T")[0];
          this.date = this.item.date.split("T")[0];

          this.time1 = this.formatTime(this.item.dateOfDischarge.split("T")[1]);
          this.time = this.formatTime(this.item.date.split("T")[1]);
          this.opis = this.item.description;
        }
      }
    },
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
    dateRazduzenja(val) {
      this.dateFormattedKupovine = this.formatDate1(this.dateRazduzenja);
    },
    dateModal(val) {
      this.dateFormattedModal = this.formatDate1(this.dateModal);
    },
    dateVazenja(val) {
      this.dateFormattedVazenja = this.formatDate1(this.dateVazenja);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date || date !== null) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
      this.time1 = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
      this.dateRazduzenja = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    getAllEmployees() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/employee/all/basic",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.employee_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/employee/all/basic",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.employee_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getFieldText(item) {
      return `${item.firstName} ${item.lastName}`;
    },
    changeArticle(a) {
      if (typeof a !== "undefined") this.jm_select = a.unitOfMeasure;
    },
    wait: function (ms) {
      var start = Date.now(),
        now = start;
      while (now - start < ms) {
        now = Date.now();
      }
    },
    clear() {
      this.setTime();
      this.setDate();

      this.$refs.form.reset();

      this.ID = 0;
    },
    // deleteItem(item) {
    //   confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
    //     this.deleteSifarnik(item.id);
    // },
    // deleteSifarnik(id) {
    //   this.$http
    //     .delete(this.globalServiceLocation + this.globalPort + "/warehouse_payment_flow/" + id, {
    //             headers: {
    //               "Content-Type": "application/json",
    //               Authorization: "Bearer  " + localStorage.getItem('user-token')
    //             }
    //           })
    //     .then(response => {
    //       this.clear();
    //     })
    //     .catch(e => {
    //       // // console.log(e.response);

    //       if (!e.response) {
    //           alert(this.$t("error.message"));
    //         } else {
    //             if (e.response.status === 401) {

    //         this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
    //           .then(result => {
    //             // // console.log(result);
    //             // // console.log("Novi token - " + localStorage.getItem("user-token"));

    //             this.$http
    //     .delete(this.globalServiceLocation + this.globalPort + "/warehouse_payment_flow/" + id, {
    //             headers: {
    //               "Content-Type": "application/json",
    //               Authorization: "Bearer  " + localStorage.getItem('user-token')
    //             }
    //           })
    //     .then(response => {
    //       this.clear();
    //     })
    //     .catch(e => {
    //       let pomError = readJSON(e.response.data.message);
    //       alert(pomError);
    //     });
    //           });
    //       } else {
    //         let pomError = readJSON(e.response.data.message);
    //         alert(pomError);
    //       }
    //         }
    //     });
    // },
    newSifarnik() {
      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var pom_employee_to_select;

      if (
        typeof this.employee_to_select !== "undefined" &&
        this.employee_to_select !== ""
      ) {
        if (typeof this.employee_to_select.id === "undefined")
          pom_employee_to_select = this.employee_to_select;
        else pom_employee_to_select = this.employee_to_select.id;
      }

      var complexObjectGive = {
        id: pom_employee_to_select,
      };

      var complexInput;

      if (this.company === undefined)
        complexInput = {
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          dateOfDischarge: this.dateRazduzenja + "T" + this.time1,
          employeePaid: complexObjectGive,
          value: this.iznos,
          currency: {
            id: 1,
          },
          description: this.opis,
        };
      else
        complexInput = {
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          dateOfDischarge: this.dateRazduzenja + "T" + this.time1,
          employeePaid: complexObjectGive,
          value: this.iznos,
          currency: {
            id: 1,
          },
          company: {
            id: this.company.id,
          },
          description: this.opis,
        };

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_payment_flow/create",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.$emit("newdata", true);

          this.clear();
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_payment_flow/create",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.$emit("newdata", true);
                      this.clear();
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var pom_employee_to_select;

      if (
        typeof this.employee_to_select !== "undefined" &&
        this.employee_to_select !== ""
      ) {
        if (typeof this.employee_to_select.id === "undefined")
          pom_employee_to_select = this.employee_to_select;
        else pom_employee_to_select = this.employee_to_select.id;
      }

      var complexObjectGive = {
        id: pom_employee_to_select,
      };

      var complexInput;

      if (this.company === undefined)
        complexInput = {
          id: this.ID,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          dateOfDischarge: this.dateRazduzenja + "T" + this.time1,
          employeePaid: complexObjectGive,
          value: this.iznos,
          currency: {
            id: 1,
          },
          description: this.opis,
        };
      else
        complexInput = {
          id: this.ID,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          dateOfDischarge: this.dateRazduzenja + "T" + this.time1,
          employeePaid: complexObjectGive,
          value: this.iznos,
          currency: {
            id: 1,
          },
          company: {
            id: this.company.id,
          },
          description: this.opis,
        };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_payment_flow/update",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.$emit("newdata", true);
          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_payment_flow/update",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.$emit("newdata", true);
                      this.clear();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    editItem(item) {
      console.log(item);
      // this.ID = item.id;
      // this.naziv = item.name;
      // this.opis = item.description;
      // this.enumLable = item.enumLable;

      this.deletable = item.isDeletable;
    },
    submit() {
      if (this.$refs.form.validate())
        if (this.ID != "" && this.ID != "0") this.changeSifarnik();
        else this.newSifarnik();
    },
  },
  mounted() {
    this.clear();
    this.getAllEmployees();
  },
};
</script>

<style lang="scss" scoped>
@import "./parts/../../assets/sass/parts/modalStyles";

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

#HistoryButton {
  // position: fixed;
  // right: 10px;
  // bottom: 20px;
  padding: 0px;
  margin: 0px;
  width: 54px;
  height: 54px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  p {
    // position: relative;
    // width: 100%;
    // height: 100%;
    i {
      position: absolute;
      left: 14px;
      top: -2px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}

.v-btn {
  min-width: 0;
}
#Odustani_dugme {
  text-align: right !important;
}
</style>
